enum MetricTypes {
  GET_AGENT_METRICS = "GET_AGENT_METRICS",
  GET_AGENT_STATUSES = "GET_AGENT_STATUSES",
  LOADING_AGENT_METRICS = "LOADING_AGENT_METRICS",
  GET_QUEUE_METRICS = "GET_QUEUE_METRICS",
  SET_STATS_QUEUE_METRICS = "SET_STATS_QUEUE_METRICS",
  SET_REALTIME_QUEUE_METRICS = "SET_REALTIME_QUEUE_METRICS",
  SET_WEBSOCKET_QUEUE_METRICS = "SET_WEBSOCKET_QUEUE_METRICS",
  SET_METRICS_CONFIG = "SET_METRICS_CONFIG",
  LOADING_QUEUE_METRICS = "LOADING_QUEUE_METRICS",
  SET_METRIC_FILTERS = "SET_METRIC_FILTERS",
  ADD_AGENT_UPDATE = "ADD_AGENT_UPDATE",
  MONITOR_AGENT = "MONITOR_AGENT",
  STOP_MONITOR_AGENT = "STOP_MONITOR_AGENT",
  SET_METRICS_CONFIG_V2 = "SET_METRICS_CONFIG_V2",
}

export enum QueueMetricDataType {
  LIVE = 'Live',
  'HISTORIC' = 'Historic',
  'HISTORIC-0.5' = 'Historic-0.5',
  'HISTORIC-1' = 'Historic-1',
  'HISTORIC-2' = 'Historic-2',
}

export default MetricTypes;
